import { UserOutlined } from "@ant-design/icons";
import { authApi, merchantApi } from "@api";
import { IConCamera, SharedInput } from "@components";
import { PATH_HOME, PATH_PRIVACY_MANAGEMENT, enumUseSetting } from "@configs";
import {
    IAddressData,
    IAmphur,
    IHandleChange,
    IProvince,
    ISubDistrict,
    ISurveyQuestions,
    IUserSetting,
} from "@interfaces";
import { selectAuth, selectMerchant } from "@redux";
import MerchantStore from "@Rocket-Innovation/components/store/useMerchantStore";
import { formatMessage, useNotify } from "@utils";
import { Avatar, Button, Col, DatePicker, Input, Row, Select, Skeleton } from "antd";
import dayjs from "dayjs";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { DATE_FORMAT_NUMBER_TH } from "src/Utils/dateUtil";
import styled from "styled-components";
import { ArrowLeftColor, PhoneIcon } from "../icon";
const { Option } = Select;
interface IProps {
    handleUploadImage: (e: React.ChangeEvent<HTMLInputElement>) => void;
    values: IUserSetting;
    handleChangeTitle: (title: enumUseSetting) => void;
    handleLinkLine: () => void;
    handleLogout: () => void;
    handleChangeName: (e: any) => void;
    handleChange: IHandleChange;
    email: string;
    setEmail: (e: any) => void;
}

const INIT_ADDRESS: IAddressData = {
    address: "",
    district: "",
    province: "",
    subDistrict: "",
    postCode: "",
};

export const ComponentUserSetting = (props: IProps) => {
    //page prop
    const {
        handleUploadImage,
        values,
        handleChangeTitle,
        handleLinkLine,
        handleLogout,
        handleChangeName,
        handleChange,
        email,
        setEmail,
    } = props;
    //page hooks
    const history = useHistory();

    const dispatch = useDispatch();
    const { error, success } = useNotify();
    const inputRef = useRef();
    //redux page
    const { userInfo } = useSelector(selectAuth);
    const merchant = useSelector(selectMerchant);
    // const staticQuestion = merchant.signUpSettings?.staticQuestion;
    const isEditName = merchant.securityConfig?.canCustomerEditName;
    //page variable
    const dateFormat = values?.dateOfBirth ? dayjs(values.dateOfBirth).format("DD/MM/YYYY") : "";

    const [nameEditAble, setNameEditAble] = useState<boolean>(false);

    // const fields = merchant.signUpSettings?.fields;
    // const groupField = userInfo?.customFields;
    const [surveyQuestions, setSurveyQuestions] = useState<ISurveyQuestions[]>([]);
    const [fields, setFields] = useState<any>(merchant?.signUpSettings?.fields);
    // const [groupField, setGroupField] = useState<IGroupFieldSignUp[]>(userInfo?.customFields || []);
    const [ansGroup, setAnsGroup] = useState<any[]>([]);

    const [addressData, setAddressData] = useState<IAddressData>(INIT_ADDRESS);
    const [provinceList, setProvinceList] = useState<IProvince[]>([]);
    const [amphurList, setAmphurList] = useState<IAmphur[]>([]);
    const [subDistrictList, setSubDistrictList] = useState<ISubDistrict[]>([]);
    const [getQuestions, setGetQuestions] = useState<any[]>([]);
    const [questionList, setQuestionList] = useState<any[]>([]);
    const [staticQuestionList, setStaticQuestionList] = useState<any[]>([]);
    const [errorMessage, setErrorMessage] = useState<any>({
        email: "",
    });
    const [isLoading, setIsloading] = useState(false);

    // derived flag to indicate if there are any validation errors
    const hasError = Object.values(errorMessage || {}).some(
        (v) => v !== undefined && v !== null && String(v).trim() !== ""
    );
    const i18nextLng = window.localStorage.i18nextLng;
    const { t } = useTranslation();

    const getFormQuestions = async () => {
        try {
            const res = await merchantApi.getFormQuestions({
                memberTypeNameId: "",
            });
            const dataQuestion = res.data.result;
            setGetQuestions(dataQuestion);
        } catch (error) {
            console.log(error);
        }
    };

    const filterGroups = (groups: any[], answers: any[], contact: any) => {
        return groups
            .map((group) => {
                // console.log("group.fields", group.fields, contact);
                const filteredFields = group.fields
                    .filter(
                        (field: any) =>
                            (field.isActiveOnProfile &&
                                field.memberTypeIdList?.includes(contact.memberTypeNameId)) ||
                            (field.isActiveOnProfile &&
                                !MerchantStore.getState().memberTypeInfo?.isPreform)
                        // field.isActiveOnProfile
                    )
                    .map((field: any) => {
                        const answer = answers.find((ans) => ans.questionId === field._id);
                        if (answer && !field.isDate) {
                            return {
                                ...field,
                                answers: field.isFreeTextAnswer
                                    ? answer.freeTextAnswer
                                    : answer.answers?.length
                                    ? answer.answers
                                    : answer.freeTextAnswer !== ""
                                    ? answer.freeTextAnswer
                                    : [],
                            };
                        }
                        if (answer && field.isDate) {
                            return {
                                ...field,
                                answers: dayjs(answer.freeTextAnswer),
                            };
                        }
                        return field;
                    });

                return filteredFields.length > 0 ? { ...group, fields: filteredFields } : null;
            })
            .filter((group) => group !== null);
    };

    const filterStaticGroups = (groups: any[], answers: any[], contact: any, contractByid: any) => {
        return groups
            .map((group) => {
                // console.log("group.fields", group.fields, contact);
                const filteredFields = group.fields
                    .filter(
                        (field: any) =>
                            (field.isActiveOnProfile &&
                                field.memberTypeIdList?.includes(contact.memberTypeNameId)) ||
                            (field.isActiveOnProfile &&
                                !MerchantStore.getState().memberTypeInfo?.isPreform)
                    )
                    .map((field: any) => {
                        // const answer = answers.find((ans) => ans.questionId === field._id);
                        const keyProp =
                            field.propertyName === "staffID"
                                ? "staffId"
                                : field.propertyName === "studentID"
                                ? "studentId"
                                : field.propertyName === "passportNo"
                                ? "passportNo"
                                : field.propertyName;
                        if (!field.isDate) {
                            if (field.propertyName !== "passportNo") {
                                return {
                                    ...field,
                                    answers: contact[keyProp],
                                };
                            } else {
                                return {
                                    ...field,
                                    answers: contractByid["passportNo"],
                                };
                            }
                        }
                        if (field.isDate) {
                            return {
                                ...field,
                                answers: contact?.[field.propertyName]
                                    ? dayjs(contact[field.propertyName])
                                    : null,
                            };
                        }
                        return field;
                    });

                return filteredFields.length > 0 ? { ...group, fields: filteredFields } : null;
            })
            .filter((group) => group !== null);
    };

    useEffect(() => {
        if (getQuestions.length > 0) {
            let customQuestion = getQuestions.filter((data) => {
                return data.groupName !== "Static Questions";
            });
            const filteredData = filterGroups(
                customQuestion,
                userInfo?.contact?.surveyQuestions || [],
                userInfo?.contact
            );
            setQuestionList(filteredData);

            let staticQuestion = getQuestions.filter((data) => {
                return data.groupName === "Static Questions";
            });
            const filteredStaticData = filterStaticGroups(
                staticQuestion,
                userInfo?.contact?.surveyQuestions || [],
                userInfo?.contact,
                userInfo
            );

            setStaticQuestionList(filteredStaticData);
            // customQuestion.forEach((fItem, fIndex)=>{

            // })
        } else getFormQuestions();
    }, [getQuestions]);

    const handleAnswerChange = (
        value: any,
        groupIndex: number,
        fieldIndex: number,
        inputType: "text" | "select" | "date"
    ) => {
        setQuestionList((prevList) => {
            const updatedList = [...prevList];
            const targetField = updatedList[groupIndex].fields[fieldIndex];

            if (inputType === "text") {
                targetField.answers = value;
            } else if (inputType === "select") {
                targetField.answers = value;
            } else if (inputType === "date") {
                targetField.answers = value ? value : null;
            }

            return updatedList;
        });
    };
    const handleStaticAnswerChange = (
        value: any,
        groupIndex: number,
        fieldIndex: number,
        inputType: "text" | "select" | "date",
        inputName?: string
    ) => {
        if (inputName === "email") {
            const emailRegex =
                /^[a-zA-Z0-9]+([._-][a-zA-Z0-9]+)*_?@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/;
            if (value && !emailRegex.test(value)) {
                setErrorMessage({
                    email: "Please enter a valid email address",
                });
                console.log("Please enter a valid email address");
            } else {
                setErrorMessage({
                    email: "",
                });
            }
        }
        if (inputName === "dateOfBirth") {
            if (!value) {
                setErrorMessage((prev: any) => ({
                    ...prev,
                    dateOfBirth: "",
                }));
            } else {
                const birthDate = value;
                const today = dayjs();
                const age = today.diff(dayjs(birthDate), "year");
                if (age < 15) {
                    setErrorMessage((prev: any) => ({
                        ...prev,
                        dateOfBirth: "Users must be at least 15 years",
                    }));
                } else if (age > 100) {
                    setErrorMessage((prev: any) => ({
                        ...prev,
                        dateOfBirth: "Users must not be over 100 years",
                    }));
                } else {
                    setErrorMessage((prev: any) => ({
                        ...prev,
                        dateOfBirth: "",
                    }));
                }
            }
        }

        setStaticQuestionList((prevList) => {
            const updatedList = [...prevList];
            const targetField = updatedList[groupIndex].fields[fieldIndex];

            if (inputType === "text") {
                targetField.answers = value;
            } else if (inputType === "select") {
                targetField.answers = value;
            } else if (inputType === "date") {
                targetField.answers = value ? value : null;
            }

            return updatedList;
        });
    };

    useEffect(() => {
        if (userInfo) {
            let groupField = userInfo?.customFields || [];
            let surveyQuestions = userInfo?.surveyQuestions || [];
            let qData: any[] = [];
            groupField.forEach((gItem, gIndex) => {
                let gObj: any = {
                    groupName: gItem.groupName,
                    isActiveOnProfile: gItem.isActiveOnProfile,
                    isActiveOnSignUp: gItem.isActiveOnSignUp,
                    isEditByAdmin: gItem.isEditByAdmin,
                    isEditByUser: gItem.isEditByUser,
                    fields: [],
                };
                gItem?.customFields.forEach((fItem, fIndex) => {
                    let outAns: any = "";
                    if (fItem.answers !== "--") {
                        outAns = fItem.answers;
                    }
                    if (fItem.answers === "--" && !fItem?.details?.multiple) {
                        let surveyAns = surveyQuestions.find(
                            (item) => item.questionId === fItem.details._id
                        );

                        if (surveyAns) {
                            outAns = surveyAns.freeTextAnswer;
                        } else {
                            outAns = fItem.answers;
                        }
                    }
                    if (fItem?.details?.multiple) {
                        if (fItem?.answers === "--") {
                            outAns = [];
                        } else {
                            outAns = fItem.answers.split(",");
                        }
                    }
                    let fObj = {
                        questionId: fItem.details._id,
                        question: fItem.displayName,
                        answers: outAns,
                        propertyName: fItem.details.propertyName,
                        isRequired: fItem.details.isRequired,
                        options: fItem?.details?.options,
                        isFreeTextAnswer: fItem?.details?.isFreeTextAnswer,
                        multiple: fItem?.details?.multiple,
                    };
                    gObj.fields.push(fObj);
                });
                qData.push(gObj);
            });
            setAnsGroup(qData);

            const firstFetchAddress = async () => {
                console.log(await merchantApi.getMemberType());

                if (userInfo?.contact?.address) {
                    await getAmphur(parseInt(userInfo?.contact?.address?.province));
                    await getSubDistrictByamphur(parseInt(userInfo?.contact?.address?.district));

                    let disIndex = subDistrictList.findIndex(
                        (item) => item?.district_id === userInfo?.contact?.address?.subDistrict
                    );
                    let payload: IAddressData = {
                        address: userInfo?.contact?.address?.address,
                        province: userInfo?.contact?.address?.province,
                        district: userInfo?.contact?.address?.district,
                        subDistrict: userInfo?.contact?.address?.subDistrict,
                        // subDistrict: disIndex !== -1 ? disIndex.toString() : "",
                        postCode: userInfo?.contact?.address?.postCode,
                    };
                    setAddressData(payload);
                }
            };
            firstFetchAddress();
        }
    }, []);

    const { themes, memberShipTiers } = useSelector(selectMerchant);

    useEffect(() => {
        getAllProvince();
    }, []);

    const getAllProvince = async () => {
        let allRes = await merchantApi.getAllProvince();
        setProvinceList(allRes.data.result);
    };
    const getAmphur = async (pId: number) => {
        let allAmphur = await merchantApi.getAmphur({
            province_id: pId,
            xpage: 1,
            xlimit: 100,
        });
        setAmphurList(allAmphur.data.result);
        let newAdd = addressData;
        newAdd.province = pId.toString();
        newAdd.district = "";
        newAdd.subDistrict = "";
        newAdd.postCode = "";
        setAddressData(newAdd);
    };
    const getSubDistrictByamphur = async (aId: number) => {
        let subRes = await merchantApi.getSubDistrict({
            amphur_id: aId,
            xpage: 1,
            xlimit: 100,
        });
        setSubDistrictList(subRes.data.result);
        let newAdd = addressData;
        newAdd.province = subRes.data.result[0]?.province_id;
        newAdd.district = aId.toString();
        newAdd.subDistrict = "";
        newAdd.postCode = "";
        setAddressData(newAdd);
    };
    const onChangeProvince = async (value: any) => {
        setAddressData({
            ...addressData,
            province: value,
        });
        await getAmphur(value);
    };
    const onChangeAmphur = async (value: any) => {
        setAddressData({
            ...addressData,
            district: value,
        });
        await getSubDistrictByamphur(value);
    };
    const onChangeSubDistrict = (value: any) => {
        // let outSub = subDistrictList[value];
        let outSub = Object.values(subDistrictList).find((item) => item.district_id === value);
        setAddressData({
            ...addressData,
            // subDistrict: outSub?.district_id,
            subDistrict: value,
            postCode: outSub?.zipcode || "",
        });
    };
    const setAddressText = (value: any, name: string) => {
        let newAdd = {
            ...addressData,
            [name]: value,
        };
        setAddressData({
            ...newAdd,
        });
    };

    const handleChangeAnswerByIndex = (
        answer: string | string[],
        gIndex: number,
        fIndex: number
    ) => {
        let outAns: any = "";
        if (Array.isArray(answer)) {
            outAns = answer;
        } else {
            outAns = [answer];
        }
        let gList = ansGroup;
        gList[gIndex].fields[fIndex].answers = outAns;
        setAnsGroup([...gList]);
    };
    // const saveQuestion = async () => {
    //     await null;
    //     const formatAnswer = questionList.flatMap((item) => {
    //         return item.fields.map((fItem: any) => {
    //             if (fItem.isRequired) {
    //                 if (!fItem.answers) {
    //                     error(t("page.pls_answer_questions"));
    //                     throw new Error(
    //                         `Field "${fItem.fieldName}" is required but has no answer.`
    //                     );
    //                 }
    //             }
    //             return {
    //                 questionId: fItem.questionId || "",
    //                 question: fItem.fieldName || "",
    //                 answers: fItem.isFreeTextAnswer || fItem.isDate ? [] : fItem.answers || [],
    //                 propertyName: fItem.propertyName || "",
    //                 freeTextAnswer:
    //                     fItem.isFreeTextAnswer || fItem.isDate ? fItem.answers || "" : "",
    //                 isRequired: fItem.isRequired,
    //                 isMandatory: fItem.isMandatory,
    //             };
    //         });
    //     });
    //     console.log("questionList ==>", formatAnswer);
    // };

    const saveQuestion = async () => {
        await null;
        setIsloading(true);
        try {
            // Prevent saving if there are validation errors present
            if (hasError) {
                error(t("page.please_fix_errors"));
                return;
            }
            let outFull = "";
            let outF = "";
            let outL = "";
            if (merchant?.advanceSettings?.tier?.isFullName) {
                outFull = values.fullName || "";
                let nameSplit = (values.fullName || "").split(" ");
                outF = nameSplit[0];
                outL = nameSplit?.[1] || "";
            } else {
                outF = values.fName || "";
                outL = values.lName || "";
                outFull = values.fName + " " + values.lName;
            }
            if (email === "") {
                error("Please enter email");
                return;
            }
            let namePayload = {
                fullName: outFull,
                firstName: outF,
                lastName: outL,
                ...(email !== "" && { email: email }),
            };
            // let profileRes = await authApi.updateProfile(namePayload);
            // if (profileRes.data.message) {
            //     dispatch(getInfo());
            //     success(profileRes.data.message);
            // }
            // let outAnsList: ISurveyQuestions[] = [];
            // ansGroup.forEach((aItem, aIndex) => {
            //     if (aItem?.isEditByUser) {
            //         aItem?.fields?.forEach((fItem: any, fIndex: number) => {
            //             let outAns = fItem.answers;
            //             let outText = "";
            //             if (fItem?.isFreeTextAnswer) {
            //                 outAns = [];
            //                 outText = fItem.answers;
            //             } else if (!fItem?.multiple) {
            //                 outAns = [];
            //                 outText = fItem.answers[0];
            //             }
            //             let checkEmpty = true;
            //             if (fItem?.isRequired) {
            //                 if (fItem?.isFreeTextAnswer) {
            //                     if (fItem?.answers === "" || fItem?.answers?.length === 0) {
            //                         checkEmpty = false;
            //                     }
            //                 } else {
            //                     if (fItem?.answers?.length === 0) {
            //                         checkEmpty = false;
            //                     }
            //                 }
            //             } else {
            //                 if (fItem?.isFreeTextAnswer) {
            //                     if (fItem?.answers === "" || fItem?.answers?.length === 0) {
            //                         checkEmpty = false;
            //                     }
            //                 } else {
            //                     if (fItem?.answers?.length === 0) {
            //                         checkEmpty = false;
            //                     }
            //                 }
            //             }
            //             if (checkEmpty) {
            //                 let outObj = {
            //                     // answers: fItem?.isFreeTextAnswer ? [] : fItem.answers,
            //                     // freeTextAnswer: fItem?.isFreeTextAnswer ? fItem.answers : "",
            //                     answers: outAns,
            //                     freeTextAnswer: outText,
            //                     isRequired: fItem?.isRequired,
            //                     propertyName: fItem?.propertyName,
            //                     question: fItem?.question,
            //                     questionId: fItem?.questionId,
            //                 };
            //                 outAnsList.push(outObj);
            //             }
            //         });
            //     }
            // });
            // const checking = outAnsList.map(
            //     (item: any) =>
            //         item.isRequired &&
            //         (item?.freeTextAnswer ? item?.freeTextAnswer === "" : item.answers.length === 0)
            // );
            // const isRequired = checking.find((item: any) => item === true);
            // if (isRequired) {
            //     error(t("page.pls_answer_questions"));
            //     return;
            // }
            // if (!staticQuestion?.address?.isRedeem) {
            //     if (staticQuestion?.address?.isRequired) {
            //         if (
            //             addressData?.address === "" ||
            //             addressData?.province === "" ||
            //             addressData?.district === "" ||
            //             addressData?.subDistrict === "" ||
            //             addressData?.postCode === ""
            //         ) {
            //             error(t("page.pls_answer_address"));
            //             return;
            //         }
            //     }
            // }

            // let updateRes = await authApi.updateAnswer({
            //     surveyQuestions: outAnsList,
            // });
            let outSubDisIndex = 0;
            if (addressData?.subDistrict !== "") {
                outSubDisIndex = parseInt(addressData.subDistrict);
            }

            let proObj = provinceList.find((item) => item?.province_id === addressData?.province);
            let disObj = amphurList.find((item) => item?.amphur_id === addressData.district);
            let subObj = subDistrictList.find(
                (item) => item?.district_id === addressData?.subDistrict
            );
            // let subObj = subDistrictList[parseInt(addressData?.subDistrict)];
            let fullAdd = [
                addressData?.address,
                proObj?.province_name_tha,
                disObj?.amphur_name_tha,
                subObj?.district_name_tha,
                addressData.postCode,
            ].join(" ");

            console.log("subDistrict =>", addressData.subDistrict);

            let addressPayload: any = {
                address: {
                    ...addressData,
                    // subDistrict:
                    //     addressData.subDistrict !== ""
                    //         ? subDistrictList[outSubDisIndex]?.district_id
                    //         : "",
                    // subDistrict: subDistrictList[subDis]?.district_id || "",
                },
                fullAddress: fullAdd,
            };

            const formatAnswer = questionList.flatMap((item) => {
                return item.fields.map((fItem: any) => {
                    if (fItem.isRequired && fItem.propertyName !== "address") {
                        if (!fItem.answers) {
                            error(t("page.pls_answer_questions"));
                            throw new Error(
                                `Field "${fItem.fieldName}" is required but has no answer.`
                            );
                        }
                    }
                    return {
                        questionId: fItem._id || "",
                        question: fItem.fieldName || "",
                        answers: fItem.isFreeTextAnswer || fItem.isDate ? [] : fItem.answers || [],
                        propertyName: fItem.propertyName || "",
                        freeTextAnswer:
                            fItem.isFreeTextAnswer || fItem.isDate ? fItem.answers || "" : "",
                        isRequired: fItem.isRequired,
                        isMandatory: fItem.isMandatory,
                    };
                });
            });
            const formatStaticAnswer = staticQuestionList.flatMap((item) => {
                return item.fields
                    .map((fItem: any) => {
                        // Exclude email if not required and not answered
                        if (
                            fItem.propertyName === "email" &&
                            !fItem.isRequired &&
                            (!fItem.answers ||
                                fItem.answers === "" ||
                                (Array.isArray(fItem.answers) && fItem.answers.length === 0))
                        ) {
                            return null;
                        }
                        if (fItem.isRequired) {
                            if (fItem.propertyName === "address") {
                                if (!addressData.address) {
                                    throw new Error(
                                        `Field "${fItem.fieldName}" is required but has no answer.`
                                    );
                                } else if (!addressData.province) {
                                    throw new Error(
                                        `Field "${t(
                                            "page.province"
                                        )}" is required but has no answer.`
                                    );
                                } else if (!addressData.district) {
                                    throw new Error(
                                        `Field "${t(
                                            "page.district"
                                        )}" is required but has no answer.`
                                    );
                                } else if (!addressData.subDistrict) {
                                    throw new Error(
                                        `Field "${t(
                                            "page.sub_district"
                                        )}" is required but has no answer.`
                                    );
                                } else if (!addressData.postCode) {
                                    throw new Error(
                                        `Field "${t(
                                            "page.post_code"
                                        )}" is required but has no answer.`
                                    );
                                }
                            }
                            if (!fItem.answers && fItem.propertyName !== "address") {
                                error(t("page.pls_answer_questions"));
                                throw new Error(
                                    `Field "${fItem.fieldName}" is required but has no answer.`
                                );
                            } else if (fItem.propertyName === "email") {
                                if (errorMessage.email) {
                                    throw new Error(errorMessage.email);
                                }
                            }
                        }

                        return {
                            questionId: fItem._id || "",
                            question: fItem.fieldName || "",
                            answers:
                                fItem.isFreeTextAnswer || fItem.isDate ? [] : fItem.answers || [],
                            propertyName: fItem.propertyName || "",
                            freeTextAnswer:
                                fItem.isFreeTextAnswer || fItem.isDate ? fItem.answers || "" : "",
                            isRequired: fItem.isRequired,
                            isMandatory: fItem.isMandatory,
                        };
                    })
                    .filter((f: any) => f !== null);
            });
            const removeAddr = formatStaticAnswer.filter((item) => item.propertyName !== "address");
            const updateRes = await authApi.saveClientQuestions([...formatAnswer, ...removeAddr]);

            if (fullAdd) {
                let addressRes = await authApi.saveQuestionSignUp(addressPayload);
            }

            const propertyMap: Record<string, string> = {
                staffid: "staffId",
                staffID: "staffId",
                sellerid: "sellerId",
                sellerID: "sellerId",
                studentid: "studentId",
                studentID: "studentId",
            };

            const resultStatic = removeAddr.reduce((acc: Record<string, string>, item) => {
                const normalizedKey = item.propertyName.toLowerCase();
                const finalKey = propertyMap[normalizedKey] || item.propertyName;
                acc[finalKey] = item.propertyName === "gender" ? item.answers : item.freeTextAnswer;
                return acc;
            }, {});
            const cleanedResultStatic = Object.fromEntries(
                Object.entries(resultStatic).filter(([key, value]) => {
                    if (value === "" || value === undefined || value === null) return false;
                    if (Array.isArray(value) && value.length === 0) return false;
                    return true;
                })
            );
            const payloadStatic = {
                ...(cleanedResultStatic.firstName && {
                    fullName:
                        cleanedResultStatic.firstName + " " + cleanedResultStatic.lastName || "",
                }),
                ...cleanedResultStatic,
                dateOfBirth: cleanedResultStatic.dateOfBirth || null,
                // ...resultStatic,
            };
            let profileRes = await authApi.updateProfile(payloadStatic);
            if (profileRes.data.message) {
                // dispatch(getInfo());
                success(profileRes.data.message);
            }
            // dispatch(fetchUser());
            success(t("message.update.success"));
            history.push(PATH_HOME);
        } catch (errors: any) {
            // const errorsResponse = errors.response.data.errors;
            if (errors.response) {
                error(formatMessage(errors.response));
            } else {
                console.log("errors ===>", errors);
                error(errors.message);
            }
        } finally {
            setIsloading(false);
        }
    };

    const handleAnserText = (value: string | string[], gIndex: number, fIndex: number) => {
        //
        let gList = ansGroup;
        gList[gIndex].fields[fIndex].answers = value;
        setAnsGroup([...gList]);
    };

    const changeImg = (e: React.ChangeEvent<HTMLInputElement>) => {
        handleUploadImage(e);
        //@ts-ignore
        inputRef.current.value = "";
    };

    const goHome = () => {
        // history.push(PATH_HOME);
        history.goBack();
    };
    const handleClickPdpa = () => {
        history.push(PATH_PRIVACY_MANAGEMENT);
    };

    return (
        <>
            <StyleCoporateProfile>
                <Skeleton
                    avatar
                    active
                    loading={isLoading}
                    title={{ width: 90 }}
                    paragraph={{ rows: 1, width: 171 }}
                >
                    <StyledUserSetting avatarCheck={!!values?.avatar} className="user-setting">
                        <div className="btn-back">
                            <ArrowLeftColor color={themes?.themeColor} onClick={goHome} />
                        </div>
                        <h1>Edit Profile</h1>
                        <input
                            //@ts-ignore
                            ref={inputRef}
                            type="file"
                            hidden
                            id="uploadImage"
                            onChange={changeImg}
                            accept="image/png, image/jpeg, image/jpg"
                        />

                        <div className="image">
                            <div className="box_image">
                                {values?.avatar ? (
                                    <Avatar alt="Avatar" size={120} src={values?.avatar} />
                                ) : (
                                    <Avatar alt="Avatar" size={120} icon={<UserOutlined />} />
                                )}
                                <label className="camera" htmlFor="uploadImage">
                                    <IConCamera size={26} />
                                </label>
                            </div>
                        </div>
                        <div className="content">
                            <StyledSurvey mainColor={themes?.themeColor!}>
                                {staticQuestionList.map((item: any, index: number) => {
                                    return (
                                        <div key={index}>
                                            {item.fields.map((fItem: any, fIndex: number) => {
                                                return (
                                                    <div key={fIndex}>
                                                        <p
                                                            className={
                                                                "input-title " +
                                                                `${
                                                                    fItem?.multiple &&
                                                                    "multiple-title"
                                                                }`
                                                            }
                                                        >
                                                            {!fItem?.isAddress && fItem.fieldName}
                                                            {!fItem?.isAddress &&
                                                                fItem?.isRequired && (
                                                                    <span style={{ color: "red" }}>
                                                                        {" "}
                                                                        *{" "}
                                                                    </span>
                                                                )}
                                                        </p>
                                                        {fItem?.isFreeTextAnswer === true &&
                                                            !fItem?.isAddress && (
                                                                <SharedInput
                                                                    name="freeTextAnswer"
                                                                    value={fItem?.answers || ""}
                                                                    errors={
                                                                        errorMessage[
                                                                            fItem?.propertyName
                                                                        ]
                                                                    }
                                                                    style={{
                                                                        backgroundColor: "white",
                                                                        cursor: "default",
                                                                        marginTop: "-4px",
                                                                        ...(fItem?.isEditByUser
                                                                            ? {
                                                                                  border: "1px solid #eee",
                                                                              }
                                                                            : { border: "none" }),
                                                                    }}
                                                                    disable={!fItem?.isEditByUser}
                                                                    onChange={(e: any) => {
                                                                        handleStaticAnswerChange(
                                                                            e.target.value,
                                                                            index,
                                                                            fIndex,
                                                                            "text",
                                                                            fItem?.propertyName
                                                                        );
                                                                    }}
                                                                />
                                                            )}

                                                        {fItem?.isFreeTextAnswer === false &&
                                                            !fItem?.isDate && (
                                                                <Select
                                                                    className="select-fields"
                                                                    value={
                                                                        fItem?.answers?.length ===
                                                                            1 &&
                                                                        fItem?.answers[0] === ""
                                                                            ? []
                                                                            : fItem?.answers
                                                                    }
                                                                    mode={
                                                                        fItem?.multiple
                                                                            ? "multiple"
                                                                            : undefined
                                                                    }
                                                                    disabled={!fItem?.isEditByUser}
                                                                    onChange={(value: string[]) =>
                                                                        handleStaticAnswerChange(
                                                                            value,
                                                                            index,
                                                                            fIndex,
                                                                            "select",
                                                                            fItem?.propertyName
                                                                        )
                                                                    }
                                                                    showArrow={true}
                                                                >
                                                                    {fItem?.options?.map(
                                                                        (
                                                                            oItem: any,
                                                                            oIndex: number
                                                                        ) => {
                                                                            return (
                                                                                <Option
                                                                                    key={oIndex}
                                                                                    value={
                                                                                        oItem?.optionName
                                                                                    }
                                                                                >
                                                                                    {
                                                                                        oItem?.optionName
                                                                                    }
                                                                                </Option>
                                                                            );
                                                                        }
                                                                    )}
                                                                </Select>
                                                            )}

                                                        {fItem?.isDate && (
                                                            <div>
                                                                <DatePicker
                                                                    style={{
                                                                        width: "100%",
                                                                        height: "48px",
                                                                    }}
                                                                    allowClear
                                                                    value={fItem?.answers || null}
                                                                    disabled={!fItem?.isEditByUser}
                                                                    format={DATE_FORMAT_NUMBER_TH}
                                                                    onChange={(date) => {
                                                                        handleStaticAnswerChange(
                                                                            date,
                                                                            index,
                                                                            fIndex,
                                                                            "date",
                                                                            fItem?.propertyName
                                                                        );
                                                                        console.log(
                                                                            "dateOfBirth ==>",
                                                                            date
                                                                        );
                                                                    }}
                                                                />
                                                                {errorMessage.dateOfBirth && (
                                                                    <div
                                                                        style={{
                                                                            color: "red",
                                                                            marginTop: 4,
                                                                        }}
                                                                    >
                                                                        {errorMessage.dateOfBirth}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )}
                                                        {fItem?.isAddress && (
                                                            <div>
                                                                <br />
                                                                {/* <div className="group-title-section">
                                                        <div className="color-section">&nbsp;</div>
                                                        <div className="group-title">
                                                            {t("page.address")}
                                                        </div>
                                                    </div> */}
                                                                <div>
                                                                    <p className="input-title ">
                                                                        {t("page.address")}
                                                                        {fItem?.isRequired && (
                                                                            <span
                                                                                style={{
                                                                                    color: "red",
                                                                                }}
                                                                            >
                                                                                {" "}
                                                                                *{" "}
                                                                            </span>
                                                                        )}
                                                                    </p>

                                                                    <SharedInput
                                                                        name="address"
                                                                        disable={
                                                                            !fItem?.isEditByUser
                                                                        }
                                                                        value={addressData?.address}
                                                                        onChange={(
                                                                            e: React.ChangeEvent<HTMLFormElement>
                                                                        ) =>
                                                                            setAddressText(
                                                                                e.target.value,
                                                                                "address"
                                                                            )
                                                                        }
                                                                        // styleParent={{ height: "48px" }}
                                                                        style={{
                                                                            backgroundColor:
                                                                                "white",
                                                                            border: "1px solid gray",
                                                                        }}
                                                                    />
                                                                    <div>
                                                                        <Row gutter={16}>
                                                                            <Col span={12}>
                                                                                <p className="input-title ">
                                                                                    {t(
                                                                                        "page.province"
                                                                                    )}
                                                                                </p>
                                                                            </Col>
                                                                            <Col span={12}>
                                                                                <p className="input-title ">
                                                                                    อำเภอ
                                                                                </p>
                                                                            </Col>
                                                                            <Col span={12}>
                                                                                <Select
                                                                                    onChange={
                                                                                        onChangeProvince
                                                                                    }
                                                                                    disabled={
                                                                                        !fItem?.isEditByUser
                                                                                    }
                                                                                    value={
                                                                                        addressData.province ===
                                                                                        ""
                                                                                            ? undefined
                                                                                            : addressData.province
                                                                                    }
                                                                                    // value={date.day === "" ? undefined : date.day}
                                                                                    placeholder={t(
                                                                                        "page.province"
                                                                                    )}
                                                                                >
                                                                                    {provinceList?.length >
                                                                                        0 &&
                                                                                        provinceList?.map(
                                                                                            (
                                                                                                pItem,
                                                                                                pIndex
                                                                                            ) => {
                                                                                                return (
                                                                                                    <Option
                                                                                                        value={
                                                                                                            pItem?.province_id
                                                                                                        }
                                                                                                        key={
                                                                                                            pIndex
                                                                                                        }
                                                                                                    >
                                                                                                        {
                                                                                                            pItem.province_name_tha
                                                                                                        }
                                                                                                    </Option>
                                                                                                );
                                                                                            }
                                                                                        )}
                                                                                </Select>
                                                                            </Col>
                                                                            <Col span={12}>
                                                                                <Select
                                                                                    onChange={
                                                                                        onChangeAmphur
                                                                                    }
                                                                                    disabled={
                                                                                        !fItem?.isEditByUser
                                                                                    }
                                                                                    value={
                                                                                        addressData.district ===
                                                                                        ""
                                                                                            ? undefined
                                                                                            : addressData.district
                                                                                    }
                                                                                    // value={date.month === "" ? undefined : date.month}
                                                                                    placeholder="อำเภอ"
                                                                                >
                                                                                    {amphurList?.length >
                                                                                        0 &&
                                                                                        amphurList?.map(
                                                                                            (
                                                                                                aItem,
                                                                                                aIndex
                                                                                            ) => {
                                                                                                return (
                                                                                                    <Option
                                                                                                        value={
                                                                                                            aItem?.amphur_id
                                                                                                        }
                                                                                                        key={
                                                                                                            aIndex
                                                                                                        }
                                                                                                    >
                                                                                                        {
                                                                                                            aItem?.amphur_name_tha
                                                                                                        }
                                                                                                    </Option>
                                                                                                );
                                                                                            }
                                                                                        )}
                                                                                </Select>
                                                                            </Col>
                                                                        </Row>
                                                                    </div>
                                                                    <div>
                                                                        <Row gutter={16}>
                                                                            <Col span={12}>
                                                                                <p className="input-title ">
                                                                                    ตำบล
                                                                                </p>
                                                                            </Col>
                                                                            <Col span={12}>
                                                                                <p className="input-title ">
                                                                                    {t(
                                                                                        "page.zipcode"
                                                                                    )}
                                                                                </p>
                                                                            </Col>
                                                                            <Col span={12}>
                                                                                <Select
                                                                                    disabled={
                                                                                        !fItem?.isEditByUser
                                                                                    }
                                                                                    onChange={
                                                                                        onChangeSubDistrict
                                                                                    }
                                                                                    value={
                                                                                        addressData.subDistrict ===
                                                                                        ""
                                                                                            ? undefined
                                                                                            : addressData.subDistrict
                                                                                    }
                                                                                    // value={date.day === "" ? undefined : date.day}
                                                                                    placeholder="ตำบล"
                                                                                >
                                                                                    {subDistrictList?.length >
                                                                                        0 &&
                                                                                        subDistrictList?.map(
                                                                                            (
                                                                                                sItem,
                                                                                                sIndex
                                                                                            ) => {
                                                                                                return (
                                                                                                    <Option
                                                                                                        value={
                                                                                                            sItem?.district_id
                                                                                                        }
                                                                                                        key={
                                                                                                            sIndex
                                                                                                        }
                                                                                                    >
                                                                                                        {
                                                                                                            sItem?.district_name_tha
                                                                                                        }
                                                                                                    </Option>
                                                                                                );
                                                                                            }
                                                                                        )}
                                                                                </Select>
                                                                            </Col>
                                                                            <Col span={12}>
                                                                                <SharedInput
                                                                                    name="freeTextAnswer"
                                                                                    disable={true}
                                                                                    value={
                                                                                        addressData?.postCode
                                                                                    }
                                                                                    onChange={(
                                                                                        e: React.ChangeEvent<HTMLFormElement>
                                                                                    ) =>
                                                                                        setAddressText(
                                                                                            e.target
                                                                                                .value,
                                                                                            "postCode"
                                                                                        )
                                                                                    }
                                                                                    // styleParent={{ height: "48px" }}
                                                                                    style={{
                                                                                        backgroundColor:
                                                                                            "white",
                                                                                        border: "1px solid gray",
                                                                                    }}
                                                                                />
                                                                            </Col>
                                                                        </Row>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    );
                                })}
                            </StyledSurvey>
                            {/* {nameEditAble === false ? (
                    <>
                        {merchant?.advanceSettings?.tier?.isFullName ? (
                            <StyledFieldSection>
                                <div className="title">{t("page.fullname")}</div>
                                <Input
                                    className="profile-input"
                                    value={values?.fullName}
                                    disabled={isEditName ? false : true}
                                    name="fullName"
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                        //cut double space
                                        e.target.value = e.target.value.replace(/\s{2,}/g, " ");
                                        e.target.value = e.target.value.replace(/\./g, "");
                                        handleChangeName(e);
                                    }}
                                    size="large"
                                    suffix={<></>}
                                />
                            </StyledFieldSection>
                        ) : (
                            <StyledFieldSection>
                                <div className="title">{t("page.name")}</div>
                                <Input
                                    className="profile-input"
                                    value={values?.fName}
                                    name="fName"
                                    disabled={isEditName ? false : true}
                                    onChange={handleChangeName}
                                    size="large"
                                    suffix={<></>}
                                />
                                <br />
                                <br />
                                <div className="title">{t("page.surname")}</div>
                                <Input
                                    className="profile-input"
                                    value={values?.lName}
                                    disabled={isEditName ? false : true}
                                    name="lName"
                                    onChange={handleChangeName}
                                    size="large"
                                    suffix={<></>}
                                />
                            </StyledFieldSection>
                        )}
                    </>
                ) : (
                    <>
                        {merchant?.advanceSettings?.tier?.isFullName ? (
                            <StyledFieldSection>
                                <div className="title">{t("page.fullname")}</div>
                                <Input
                                    className="profile-input"
                                    value={values?.fullName}
                                    // disabled
                                    name="fullName"
                                    onChange={handleChangeName}
                                    size="large"
                                    suffix={<></>}
                                />
                            </StyledFieldSection>
                        ) : (
                            <StyledFieldSection>
                                <div className="title">{t("page.name")}</div>
                                <Input
                                    className="profile-input"
                                    value={values?.fName}
                                    name="fName"
                                    // disabled
                                    onChange={handleChangeName}
                                    size="large"
                                    suffix={<></>}
                                />
                                <br />
                                <br />
                                <div className="title">{t("page.surname")}</div>
                                <Input
                                    className="profile-input"
                                    value={values?.lName}
                                    // disabled
                                    name="lName"
                                    onChange={handleChangeName}
                                    size="large"
                                    suffix={<></>}
                                />
                            </StyledFieldSection>
                        )}
                    </>
                )} */}

                            {/* <StyledFieldSection>
                    <div className="title">{t("page.name")}</div>
                    <Input
                        className="profile-input"
                        value={values?.fullName}
                        // disabled
                        onChange={handleChangeName}
                        size="large"
                        suffix={
                            <></>
                        }
                    />
                </StyledFieldSection> */}
                            {/* <StyledFieldSection>
                    <div className="title">{t("page.date_of_birth")}</div>
                    <Input
                        className="profile-input"
                        value={dateFormat || "---"}
                        disabled
                        size="large"
                        suffix={<CalendarIcon />}
                    />
                </StyledFieldSection> */}
                            {merchant?.securityConfig?.canCustomerEditTel ? (
                                <div className="custom-layout-tel" style={{ alignItems: "center" }}>
                                    <StyledFieldSection>
                                        <div className="title">{t("page.phone_number")}</div>
                                        <Input
                                            className="profile-input"
                                            value={values?.phoneNumber || "---"}
                                            disabled
                                            size="large"
                                            suffix={
                                                // <span
                                                //     onClick={() => handleChangeTitle(enumUseSetting.PHONE_NUMBER)}
                                                // >
                                                //     <PhoneIcon />
                                                // </span>
                                                <PhoneIcon />
                                            }
                                        />
                                    </StyledFieldSection>
                                    <span className="layoutright">
                                        <StyledUsedBtn
                                            className="btn-redeem"
                                            themeColor={themes?.themeColor!}
                                            onClick={() =>
                                                handleChangeTitle(enumUseSetting.PHONE_NUMBER)
                                            }
                                        >
                                            {t("page.edit")}
                                        </StyledUsedBtn>
                                    </span>
                                </div>
                            ) : (
                                <StyledFieldSection>
                                    <div className="title">{t("page.phone_number")}</div>
                                    <Input
                                        className="profile-input"
                                        value={values?.phoneNumber || "---"}
                                        disabled
                                        size="large"
                                        suffix={<PhoneIcon />}
                                    />
                                </StyledFieldSection>
                            )}

                            {/* <StyledFieldSection>
                    <div className="title">{t("page.email")}</div>
                    <Input
                        className="profile-input"
                        value={email}
                        // disabled
                        size="large"
                        onChange={(e: any) => setEmail(e.target.value)}
                        name="email"
                        id="email"
                        suffix={
                            <span
                            // onClick={() => handleChangeTitle(enumUseSetting.EMAIL)}
                            >
                                <EmailIcon />
                            </span>
                        }
                    />
                </StyledFieldSection> */}

                            {/* {!staticQuestion?.address?.isRedeem && (
                    <StyledSurvey mainColor={themes?.themeColor!}>
                        <br />
                        <div className="group-title-section">
                            <div className="color-section">&nbsp;</div>
                            <div className="group-title">{t("page.address")}</div>
                        </div>
                        <div>
                            <p className="input-title ">{t("page.address")}</p>
                            <SharedInput
                                name="address"
                                value={addressData?.address}
                                onChange={(e: React.ChangeEvent<HTMLFormElement>) =>
                                    setAddressText(e.target.value, "address")
                                }
                                // styleParent={{ height: "48px" }}
                                style={{
                                    backgroundColor: "white",
                                    border: "1px solid gray",
                                }}
                            />
                            <div>
                                <Row gutter={16}>
                                    <Col span={12}>
                                        <p className="input-title ">{t("page.province")}</p>
                                    </Col>
                                    <Col span={12}>
                                        <p className="input-title ">อำเภอ</p>
                                    </Col>
                                    <Col span={12}>
                                        <Select
                                            onChange={onChangeProvince}
                                            value={
                                                addressData.province === ""
                                                    ? undefined
                                                    : addressData.province
                                            }
                                            // value={date.day === "" ? undefined : date.day}
                                            placeholder={t("page.province")}
                                        >
                                            {provinceList?.length > 0 &&
                                                provinceList?.map((pItem, pIndex) => {
                                                    return (
                                                        <Option
                                                            value={pItem?.province_id}
                                                            key={pIndex}
                                                        >
                                                            {pItem.province_name_tha}
                                                        </Option>
                                                    );
                                                })}
                                        </Select>
                                    </Col>
                                    <Col span={12}>
                                        <Select
                                            onChange={onChangeAmphur}
                                            value={
                                                addressData.district === ""
                                                    ? undefined
                                                    : addressData.district
                                            }
                                            // value={date.month === "" ? undefined : date.month}
                                            placeholder="อำเภอ"
                                        >
                                            {amphurList?.length > 0 &&
                                                amphurList?.map((aItem, aIndex) => {
                                                    return (
                                                        <Option
                                                            value={aItem?.amphur_id}
                                                            key={aIndex}
                                                        >
                                                            {aItem?.amphur_name_tha}
                                                        </Option>
                                                    );
                                                })}
                                        </Select>
                                    </Col>
                                </Row>
                            </div>
                            <div>
                                <Row gutter={16}>
                                    <Col span={12}>
                                        <p className="input-title ">ตำบล</p>
                                    </Col>
                                    <Col span={12}>
                                        <p className="input-title ">{t("page.zipcode")}</p>
                                    </Col>
                                    <Col span={12}>
                                        <Select
                                            onChange={onChangeSubDistrict}
                                            value={
                                                addressData.subDistrict === ""
                                                    ? undefined
                                                    : addressData.subDistrict
                                            }
                                            // value={date.day === "" ? undefined : date.day}
                                            placeholder="ตำบล"
                                        >
                                            {subDistrictList?.length > 0 &&
                                                subDistrictList?.map((sItem, sIndex) => {
                                                    return (
                                                        <Option
                                                            value={sItem?.district_id}
                                                            key={sIndex}
                                                        >
                                                            {sItem?.district_name_tha}
                                                        </Option>
                                                    );
                                                })}
                                        </Select>
                                    </Col>
                                    <Col span={12}>
                                        <SharedInput
                                            name="freeTextAnswer"
                                            value={addressData?.postCode}
                                            onChange={(e: React.ChangeEvent<HTMLFormElement>) =>
                                                setAddressText(e.target.value, "postCode")
                                            }
                                            // styleParent={{ height: "48px" }}
                                            style={{
                                                backgroundColor: "white",
                                                border: "1px solid gray",
                                            }}
                                        />
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </StyledSurvey>
                )} */}
                            <StyledSurvey mainColor={themes?.themeColor!}>
                                {questionList.map((item: any, index: number) => {
                                    return (
                                        <div key={index}>
                                            <br />
                                            <div className="group-title-section">
                                                <div className="color-section">&nbsp;</div>
                                                <div className="group-title">{item?.groupName}</div>
                                            </div>
                                            {item.fields.map((fItem: any, fIndex: number) => {
                                                return (
                                                    <div key={fIndex}>
                                                        <p
                                                            className={
                                                                "input-title " +
                                                                `${
                                                                    fItem?.multiple &&
                                                                    "multiple-title"
                                                                }`
                                                            }
                                                        >
                                                            {fItem.fieldName}
                                                            {fItem?.isRequired && (
                                                                <span style={{ color: "red" }}>
                                                                    {" "}
                                                                    *{" "}
                                                                </span>
                                                            )}
                                                        </p>
                                                        {fItem?.isFreeTextAnswer === true && (
                                                            <SharedInput
                                                                name="freeTextAnswer"
                                                                value={fItem?.answers || ""}
                                                                style={{
                                                                    backgroundColor: "white",
                                                                    cursor: "default",
                                                                    marginTop: "-4px",
                                                                    ...(fItem?.isEditByUser
                                                                        ? {
                                                                              border: "1px solid #eee",
                                                                          }
                                                                        : { border: "none" }),
                                                                }}
                                                                disable={!fItem?.isEditByUser}
                                                                onChange={(e: any) => {
                                                                    handleAnswerChange(
                                                                        e.target.value,
                                                                        index,
                                                                        fIndex,
                                                                        "text"
                                                                    );
                                                                }}
                                                            />
                                                        )}

                                                        {fItem?.isFreeTextAnswer === false &&
                                                            !fItem?.isDate && (
                                                                <Select
                                                                    className="select-fields"
                                                                    value={
                                                                        fItem?.answers?.length ===
                                                                            1 &&
                                                                        fItem?.answers[0] === ""
                                                                            ? []
                                                                            : fItem?.answers
                                                                    }
                                                                    mode={
                                                                        fItem?.multiple
                                                                            ? "multiple"
                                                                            : undefined
                                                                    }
                                                                    disabled={!fItem?.isEditByUser}
                                                                    onChange={(value: string[]) =>
                                                                        handleAnswerChange(
                                                                            value,
                                                                            index,
                                                                            fIndex,
                                                                            "select"
                                                                        )
                                                                    }
                                                                    showArrow={true}
                                                                >
                                                                    {fItem?.options?.map(
                                                                        (
                                                                            oItem: any,
                                                                            oIndex: number
                                                                        ) => {
                                                                            return (
                                                                                <Option
                                                                                    key={oIndex}
                                                                                    value={
                                                                                        oItem?.optionName
                                                                                    }
                                                                                >
                                                                                    {
                                                                                        oItem?.optionName
                                                                                    }
                                                                                </Option>
                                                                            );
                                                                        }
                                                                    )}
                                                                </Select>
                                                            )}

                                                        {fItem?.isDate && (
                                                            <DatePicker
                                                                style={{
                                                                    width: "100%",
                                                                    height: "48px",
                                                                }}
                                                                value={fItem?.answers || null}
                                                                disabled={!fItem?.isEditByUser}
                                                                format={DATE_FORMAT_NUMBER_TH}
                                                                onChange={(date) =>
                                                                    handleAnswerChange(
                                                                        date,
                                                                        index,
                                                                        fIndex,
                                                                        "date"
                                                                    )
                                                                }
                                                            />
                                                        )}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    );
                                })}
                                <div className="btn-section">
                                    <Button
                                        onClick={() => history.push(PATH_HOME)}
                                        className="back btn"
                                    >
                                        {t("page.back")}
                                    </Button>
                                    <Button
                                        className="save btn"
                                        onClick={saveQuestion}
                                        disabled={hasError}
                                    >
                                        {t("page.save")}
                                    </Button>
                                </div>
                            </StyledSurvey>
                            {/* <StyledCartUser onClick={handleClickPdpa}>
                    <div className="user_info">
                        <div className={"desc text-sec-sub-header "}>
                            <IconPrivacy />
                            <p>{t("page.data_privacy")}</p>
                        </div>
                    </div>
                    <div className="arrowRight">
                        <ArrowRight />
                    </div>
                </StyledCartUser> */}
                            {/* <div className="line">
                    <StyledCartUser onClick={handleLogout}>
                        <div className="user_info">
                            <div className={"desc text-sec-sub-header eng"}>{t("page.logout")}</div>
                        </div>
                        <div className="arrowRight">
                            <ArrowRight />
                        </div>
                    </StyledCartUser>
                </div> */}

                            {/* <div className="line_desc">
                    {userInfo?.lineUserId ? t("page.request_link") : t("page.request_connect_link")}
                </div> */}
                        </div>
                    </StyledUserSetting>
                </Skeleton>
            </StyleCoporateProfile>
        </>
    );
};

const StyledUsedBtn = styled.button<{ themeColor: string }>`
    padding: 3px 12px;
    color: ${(p) => p.theme.colors.card};
    background: ${(p) => p.themeColor};
    border: 0.5px solid ${(p) => p.themeColor};
    border-radius: 8px;
    cursor: pointer;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
    height: 48px;
    width: 80px;
    &:active {
        background: ${(p) => p.theme.colors.color};
        color: ${(p) => p.themeColor};
    }
`;

const StyledSurvey = styled.div<{ mainColor: string }>`
    padding: 20px;

    p {
        color: #3c3c3c;
    }
    .ant-input:focus {
        border-color: ${(p) => p.mainColor}!important;
        box-shadow: none;
        position: relative;
    }
    .ant-input:focus::after {
        content: "";
        width: 100%;
        height: 100%;
        position: absolute;
        background-color: #ff0000;
        left: 0;
        top: 0;
    }
    .group-title-section {
        display: flex;
        .color-section {
            background-color: ${(p) => p.mainColor};
            border-radius: 5px;
        }
        .group-title {
            font-size: 18px;
            font-weight: 600;
            /* border-left: 4px solid ${(p) => p.mainColor}; */
            padding-left: 10px;
            line-height: 30px;
            /* margin-top: 3px; */
        }
    }
    .ant-select {
        width: 100%;
    }
    .ant-select-selection {
        box-shadow: none !important;
        height: 48px;
        font-size: 16px;
        color: inherit;
        display: flex;
        flex-direction: column;
        justify-content: center;
        border-radius: 6px;
        width: 100%;
        background-color: #fff;
        border: 1px solid #dadada;
        cursor: default;
    }
    .ant-input-disabled {
        background-color: #fafafa !important;
    }
    .ant-select-disabled {
        div {
            background-color: #fafafa;
            border: none;
        }
        li {
            background-color: #fafafa;
            div {
                background-color: #fafafa;
            }
        }
        .ant-select-search--inline {
            display: none;
        }
    }
    .intl-tel-input input {
        border-radius: 6px;
    }
    .term-field {
        display: flex;
        justify-content: center;
    }
    .btn-section {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 20px;
        margin-top: 50px;
        margin-bottom: 70px;
        .btn {
            width: 100%;
            height: 55px;
            border-radius: 500px;
            font-size: 16px;
        }
        .back {
            color: ${(p) => p.mainColor};
            background-color: #fff;
            border: 1px solid ${(p) => p.mainColor};
        }
        .save {
            //
            background-color: ${(p) => p.mainColor};
            color: white;
        }
    }
    .input-title {
        margin: 12px 0 8px 0;
        color: #919191;
        font-size: 16px;
        font-weight: 500;
    }
    .multiple-title {
        margin-bottom: 0px;
        line-height: 16px;
    }
    .ant-select-selection--multiple {
        .ant-select-arrow {
            margin-top: 0px;
        }
    }
`;

const StyledUserSetting = styled.div<{ avatarCheck: boolean }>`
    h1 {
        text-align: center;
        font-size: 22px;
        margin-top: 60px;
    }
    .custom-layout-tel {
        padding: 10px 20px;
        padding-right: 120px;
        position: relative;
        span.layoutright {
            position: absolute;
            right: 20px;
            top: calc(50% + 16px);
            transform: translateY(-50%);
        }
        > div {
            padding: 0;
        }
    }
    .btn-back {
        position: absolute;
        padding: 6px;
        left: 10px;
        top: 20px;
        &:active {
            transform: scale(0.85);
        }
        svg {
            color: #aaaaaa;
            font-size: 20px;
        }
    }
    .image {
        width: 100%;
        padding: 20px 0 46px 0;
        text-align: center;
        img {
            border-radius: 50%;
        }
    }
    .box_image {
        position: relative;
        width: fit-content;
        margin: 0 auto;
    }
    .camera {
        position: absolute;
        bottom: 2px;
        right: 2px;
        cursor: pointer;
    }
    .line {
        margin-top: 42px;
        margin-bottom: 42px;
    }
    .line_desc {
        margin: 16px 12px;

        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        color: #707070;
    }
    .content {
        background-color: ${(p) => p.theme.colors.background};
        min-height: 100vh;
    }
`;
const StyledFieldSection = styled.div`
    padding: 10px 20px;
    .title {
        color: #919191;
        font-weight: 500;
        font-size: 16px;
        margin-bottom: 8px;
    }
    .profile-input {
        /* height: 48px; */

        .ant-input-disabled {
            border: none;
            cursor: default;
            /* background-color: #fafafa; */
            top: -6px;
        }
    }
`;

const StyledCartUser = styled.div`
    padding: 9px 16px;
    background-color: ${(p) => p.theme.colors.home_bg};
    border-bottom: 1px solid #fafafa;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    .arrowRight {
    }
    &:last-child {
        border-bottom: initial;
    }
    .user_info {
        overflow: hidden;
        word-break: break-word;
        .title {
            font-style: normal;
            font-weight: 600;
            font-size: 13px;
            color: #707070;
            margin-bottom: 4px;
            line-height: inherit;
        }
        .desc {
            font-style: normal;
            color: ${(p) => p.theme.colors.color};
            display: flex;
            align-items: center;
            p {
                margin: 0;
                font-size: 16px;
                font-weight: 500;
                font-style: normal;
                color: ${(p) => p.theme.colors.color};
            }
        }
        .desc-hidden {
            visibility: hidden;
        }
    }
`;

const StyleCoporateProfile = styled.div`
    .preview {
        background-color: transparent !important;
        box-shadow: none !important;
        padding: 0 !important;
        border-radius: 0 !important;
        border: none !important;
    }
    .ant-skeleton {
        // background-color: rgba(0, 0, 0, 0.4);
        padding: 12px;
        border-radius: 14px;
        margin: 12px;
        width: calc(100% - 24px);
        .ant-skeleton-header {
            span {
                width: 46px;
                height: 46px;
            }
        }
        .ant-skeleton-title {
            height: 10px;
            border-radius: 4px;
            margin-top: 3px;
            margin-bottom: 12px;
        }
        .ant-skeleton-paragraph {
            margin-top: 0;
            li {
                height: 10px;
                border-radius: 4px;
                margin-top: 0;
                margin-bottom: 8px;
            }
        }
    }
`;
